import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

function Loader() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="text-muted-foreground text-sm tracking-widest uppercase animate-pulse">Loading…</div>
    </div>
  );
}

function Denied({ title = "Access restricted" }) {
  return (
    <div className="p-8">
      <div className="max-w-md border border-border bg-card rounded-sm p-8 text-center mt-10 mx-auto">
        <h2 className="font-head text-xl font-extrabold mb-2">{title}</h2>
        <p className="text-sm text-muted-foreground">You don't have permission to view this page. Contact an admin to request access.</p>
      </div>
    </div>
  );
}

export function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <Loader />;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

export function RequirePermission({ perm, children }) {
  const { user, loading, can } = useAuth();
  if (loading) return <Loader />;
  if (!user) return <Navigate to="/login" replace />;
  if (!can(perm)) return <Denied />;
  return children;
}

export function RequireAdmin({ children }) {
  const { user, loading, isAdmin } = useAuth();
  if (loading) return <Loader />;
  if (!user) return <Navigate to="/login" replace />;
  if (!isAdmin) return <Denied title="Admins only" />;
  return children;
}

export function RequireMaster({ children }) {
  const { user, loading, isMaster } = useAuth();
  if (loading) return <Loader />;
  if (!user) return <Navigate to="/login" replace />;
  if (!isMaster) return <Denied title="Master Admin only" />;
  return children;
}
